import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { IS_PRIVATE } from '@/common/const/env'

const loginView = () => import(/* webpackChunkName: "Login" */ '../views/login/login.vue')
const loginTransitView = () => import(/* webpackChunkName: "LoginTransit" */ '../views/login/login-transit.vue')
const cascadeLoginView = () => import(/* webpackChunkName: "CascadeLogin" */ '../views/login/cascade-login.vue')
const authorizeView = () => import(/* webpackChunkName: "Authorize" */ '../views/authorize/authorize.vue')
const dashboardView = () => import(/* webpackChunkName: "Dashboard" */ '../views/dashboard/dashboard.vue')
const overviewView = () => import(/* webpackChunkName: "Overview" */ '../views/dashboard/overview/overview.vue')
const clientView = () => import(/* webpackChunkName: "Client" */ '../views/dashboard/group/client/client.vue')
const hardwareView = () => import(/* webpackChunkName: "Hardware" */ '../views/dashboard/group/hardware/hardware.vue')
const clientAliveView = () => import(/* webpackChunkName: "ClientAlive" */ '../views/dashboard/group/client-alive/client-alive.vue')
const loarisTrojanRemoverView = () => import(/* webpackChunkName: "LoarisTrojanRemover" */ '../views/dashboard/safe-status/loaris-trojan-remover/loaris-trojan-remover.vue')
const vulnerabilityFixView = () => import(/* webpackChunkName: "vulnerabilityFix" */ '../views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.vue')
const baseLineView = () => import(/* webpackChunkName: "baseLine" */ '../views/dashboard/safe-status/base-line/base-line.vue')
const examinationStatusView = () => import(/* webpackChunkName: "ExaminationStatus" */ '../views/dashboard/safe-status/examination-status/examination-status.vue')
const securityEventView = () => import(/* webpackChunkName: "SecurityEvent" */ '../views/dashboard/safe-protection/security-event/index.vue')
const groupPolicyView = () => import(/* webpackChunkName: "GroupPolicy" */ '../views/dashboard/policy/group-policy/group-policy.vue')
const policyDeployView = () => import(/* webpackChunkName: "PolicyDeploy" */ '../views/dashboard/policy/policy-deploy/policy-deploy.vue')
const softwareDisabledView = () => import(/* webpackChunkName: "SoftwareDisabled" */ '../views/dashboard/policy/software-disabled/software-disabled.vue')
const softwareDisabledEditView = () => import(/* webpackChunkName: "SoftwareDisabledEdit" */ '../views/dashboard/policy/software-disabled-edit/software-disabled-edit.vue')
const screenWatermarkView = () => import(/* webpackChunkName: "screenWatermark" */ '../views/dashboard/data-safe/screen-watermark/screen-watermark.vue')
const screenWatermarkEditView = () => import(/* webpackChunkName: "screenWatermarkEdit" */ '../views/dashboard/data-safe/screen-watermark-edit/screen-watermark-edit.vue')
const ransomwareIncidentView = () => import(/* webpackChunkName: "ransomwareIncident" */ '../views/dashboard/data-safe/ransomware-protection/ransomware-incident.vue')
const sensitiveFileScanningView = () => import(/* webpackChunkName: "sensitiveFileScanningView" */ '../views/dashboard/data-safe/anti-external-control/sensitive-file-scanning.vue')
const sensitiveDataDiscoveryView = () => import(/* webpackChunkName: "sensitiveDataDiscoveryView" */ '../views/dashboard/data-safe/anti-external-control/data-discovery.vue')
const fileControlStrategySettingView = () => import(/* webpackChunkName: "fileControlStrategySettingView" */ '../views/dashboard/data-safe/anti-external-control/file-control-strategy-setting.vue')
const approvalTerminalFileOutsourcingView = () => import(/* webpackChunkName: "approvalTerminalFileOutsourcingView" */ '../views/dashboard/data-safe/anti-external-control/approval-terminal-file-outsourcing.vue')
const approvalCenterView = () => import(/* webpackChunkName: "approvalCenterView" */ '../views/dashboard/approval-center/index.vue')
const processControlView = () => import(/* webpackChunkName: "ProcessControl" */ '../views/dashboard/policy/process-control/process-control.vue')
const processControlEditView = () => import(/* webpackChunkName: "ProcessControlEdit" */ '../views/dashboard/policy/process-control-edit/process-control-edit.vue')
const internetRestrictionView = () => import(/* webpackChunkName: "InternetRestriction" */ '../views/dashboard/manage/internet-restriction/internet-restriction.vue')
const accessRestrictionView = () => import(/* webpackChunkName: "AccessRestriction" */ '../views/dashboard/manage/access-restriction/access-restriction.vue')
const iPAddressBlockingView = () => import(/* webpackChunkName: "AccessRestriction" */ '../views/dashboard/manage/ip-address-blocking/index.vue')
const IpAddressBlockingLogView = () => import(/* webpackChunkName: "AccessRestriction" */ '../views/dashboard/manage/ip-address-blocking/ip-address-blocking-log.vue')
const TerminalTrafficStateListView = () => import(/* webpackChunkName: "AccessRestriction" */ '../views/dashboard/manage/terminal-traffic-control/terminal-traffic-state-list/index.vue')
const TrafficControlView = () => import(/* webpackChunkName: "AccessRestriction" */ '../views/dashboard/manage/terminal-traffic-control/traffic-control/index.vue')
const popUpInterceptView = () => import(/* webpackChunkName: "popUpIntercept" */ '../views/dashboard/manage/popup-intercept/popup-intercept.vue')
const usbStatisticsView = () => import(/* webpackChunkName: "UsbStatistics" */ '../views/dashboard/data-safe/usb-manage/usb-statistics/usb-statistics.vue')
const usbApproveView = () => import(/* webpackChunkName: "usbApproveView" */ '../views/dashboard/data-safe/usb-manage/usb-approve/usb-approve.vue')
const usbPolicyView = () => import(/* webpackChunkName: "usbPolicyView" */ '../views/dashboard/data-safe/usb-manage/usb-policy/usb-policy.vue')
const usbPolicyEditView = () => import(/* webpackChunkName: "usbPolicyEditView" */ '../views/dashboard/data-safe/usb-manage/usb-policy-edit/usb-policy-edit.vue')
const bootOptimizeView = () => import(/* webpackChunkName: "BootOptimize" */ '../views/dashboard/manage/boot-optimize/boot-optimize.vue')
const softwareUsageView = () => import(/* webpackChunkName: "SoftwareUsage" */ '../views/dashboard/manage/software-usage/software-usage.vue')
const portManageView = () => import(/* webpackChunkName: "PortManage" */ '../views/dashboard/manage/port-manage/port-manage.vue')
const softwareDispatcherView = () => import(/* webpackChunkName: "SoftwareDispatcher" */ '../views/dashboard/manage/software-dispatcher/software-dispatcher.vue')
const genuineSoftwareView = () => import(/* webpackChunkName: "GenuineSoftware" */ '../views/dashboard/manage/genuine-software/genuine-software.vue')
const genuineSoftwareUsageView = () => import(/* webpackChunkName: "GenuineSoftwareUsage" */ '../views/dashboard/manage/genuine-software-usage/genuine-software-usage.vue')
const fileDispatchView = () => import(/* webpackChunkName: "FileDispatch" */ '../views/dashboard/manage/file-dispatch/file-dispatch.vue')
const softwareManageView = () => import(/* webpackChunkName: "SoftwareManage" */ '../views/dashboard/manage/software-manage/software-manage.vue')
const InviteListView = () => import(/* webpackChunkName: "AdminAccountSettings" */ '../views/dashboard/manage/invite-list/invite-list.vue')
const adminListContainerView = () => import(/* webpackChunkName: "AdminAccountSettingsPrivate" */ '../views/dashboard/_components/admin-list-container/index.vue')
const deviceStatusView = () => import(/* webpackChunkName: "DeviceStatusView" */ '../views/dashboard/safe-status/device-status/device-status.vue')
const messagePushView = () => import(/* webpackChunkName: "MessagePush" */ '../views/dashboard/notice-manage/message-push/message-push.vue')
const warningLogView = () => import(/* webpackChunkName: "WarningLog" */ '../views/dashboard/notice-manage/warning-information-log/warning-information-log.vue')
const adminLogView = () => import(/* webpackChunkName: "AdminLog" */ '../views/dashboard/notice-manage/admin-operation-log/admin-operation-log.vue')
const virusLogView = () => import(/* webpackChunkName: "VirusLog" */ '../views/dashboard/notice-manage/virus-notification-log/virus-notification-log.vue')
const HardwareModifyLogView = () => import(/* webpackChunkName: "HardwareModifyLog" */ '../views/dashboard/notice-manage/hardware-modify-log/hardware-modify-log.vue')
const SoftwareModifyLogView = () => import(/* webpackChunkName: "SoftwareModifyLog" */ '../views/dashboard/notice-manage/software-modify-log/software-modify-log.vue')
const InoutLogView = () => import(/* webpackChunkName: "InoutLog" */ '../views/dashboard/notice-manage/in-out-log/in-out-log.vue')
const SoftDisabledLogView = () => import(/* webpackChunkName: "SoftDisabledLog" */ '../views/dashboard/notice-manage/soft-disabled-log/soft-disabled-log.vue')
const ProcessControlLogView = () => import(/* webpackChunkName: "ProcessControlLog" */ '../views/dashboard/notice-manage/process-control-log/process-control-log.vue')
const GenuineSoftwareLogView = () => import(/* webpackChunkName: "GenuineSoftwareLog" */ '../views/dashboard/notice-manage/genuine-software-log/genuine-software-log.vue')
const OutboundControlLogView = () => import(/* webpackChunkName: "OutboundControlLog" */ '../views/dashboard/manage/outbound-control-log/outbound-control-log.vue')
const TroubleShootLogView = () => import(/* webpackChunkName: "TroubleShootLog" */ '../views/dashboard/notice-manage/trouble-shoot-log/trouble-shoot-log.vue')

const teamView = () => import(/* webpackChunkName: "teamView" */ '../views/team/team.vue')
const preview = () => import(/* webpackChunkName: "preview" */ '../views/preview/preview.vue')
const remoteControl = () => import(/* webpackChunkName: "RemoteControl" */ '../views/remote-control/remote-control.vue')
const remoteVnc = () => import(/* webpackChunkName: "RemoteVnc" */ '../views/remote-vnc/remote-vnc.vue')
const remoteSsh = () => import(/* webpackChunkName: "RemoteSsh" */ '../views/remote-ssh/remote-ssh.vue')
const cloudLibraryUpdateView = () => import(/* webpackChunkName: "cloudLibraryUpdate" */ '../views/cloud-library-update/cloud-library-update.vue')
const mailSetting = () => import(/* webpackChunkName: "MailSetting" */ '../views/dashboard/manage/system-settings/mail-setting/mail-setting.vue')
const systemConfig = () => import(/* webpackChunkName: "MailSetting" */ '../views/dashboard/manage/system-settings/system-config/system-config.vue')
const runStatusView = () => import(/* webpackChunkName: "RunStatus" */ '../views/dashboard/manage/run-status/run-status.vue')
const assetRegistration = () => import(/* webpackChunkName: "MailSetting" */ '../views/dashboard/manage/system-settings/asset-registration/asset-registration.vue')
const terminalDiscoveryView = () => import(/* webpackChunkName: "TerminalDiscovery" */ '../views/dashboard/manage/terminal-discovery/terminal-discovery.vue')
const versionUpdateView = () => import(/* webpackChunkName: "versionUpdate" */ '../views/dashboard/setting/version-update/version-update.vue')
const cloudFeatureOfflineLibraryView = () => import(/* webpackChunkName: "CloudFeatureOfflineLibrary" */ '../views/dashboard/setting/cloud-feature-offline-library/cloud-feature-offline-library.vue')

const serviceSubscribeView = () => import(/* webpackChunkName: "ServiceSubscribe" */ '../views/dashboard/service/service-subscribe/service-subscribe.vue')
const aiAssistantDetailView = () => import(/* webpackChunkName: "AiAssistantDetail" */ '../views/dashboard/service/service-subscribe/ai-assistant-detail/ai-assistant-detail.vue')
const mySubscribeView = () => import(/* webpackChunkName: "MySubscribe" */ '../views/dashboard/service/my-subscribe/my-subscribe.vue')
const orderHistoryView = () => import(/* webpackChunkName: "OrderHistory" */ '../views/dashboard/service/order-history/order-history.vue')
const orderHistoryPrivateView = () => import(/* webpackChunkName: "OrderHistoryPrivate" */ '../views/dashboard/service/order-history-private/order-history-private.vue')
const subscribeDetailsView = () => import(/* webpackChunkName: "SubscribeDetails" */ '../views/dashboard/service/subscribe-details/subscribe-details.vue')
const buyMoreView = () => import(/* webpackChunkName: "BuyMore" */ '../views/dashboard/service/buy-more/buy-more.vue')
const contractInfoView = () => import(/* webpackChunkName: "ContractInfo" */ '../views/dashboard/service/contract-info/index.vue')

const repairHelpView = () => import(/* webpackChunkName: "repairHelpView" */ '../views/help/repair-help/repair-help.vue')
const subscribeHelpView = () => import(/* webpackChunkName: "subscribeHelpView" */ '../views/help/subscribe-help/subscribe-help.vue')
const linuxRepairHelpView = () => import(/* webpackChunkName: "linuxRepairHelpView" */ '../views/help/repair-help/linux-repair-help.vue')
const domainDeploymentView = () => import(/* webpackChunkName: "DomainDeployment" */ '../views/help/domain-deployment/domain-deployment.vue')
const watermarkDecryptionView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/help/watermark-decryption/watermark-decryption.vue')
const fileWhitelistView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/file-whitelist/index.vue')
// 级联中心
const cascadeBranchOverviewView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/cascade-center/branch-overview/branch-overview.vue')
const cascadeManageView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/cascade-center/cascade-manage/index.vue')
const cascadeApprovalView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/cascade-center/approval/index.vue')
// 响应中心
const responseHandleView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/response-manage/response-handle/index.vue')
const wordRemoteView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/remote-authentication/components/word-remote.vue')
// 远程登录认证
const remoteAuthenticationStrategyView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/remote-authentication/index.vue')
const remoteAuthenticationLoginLogyView = () => import(/* webpackChunkName: "WatermarkDecryption" */ '../views/dashboard/remote-authentication/remote-login-log.vue')
// ldap同步设置
const ldapSyncSettingView = () => import(/* webpackChunkName: "MailSetting" */ '../views/dashboard/manage/system-settings/ldap-sync-setting/index.vue')
// 密码重置（邮件回调）
const passwordResetView = () => import(/* webpackChunkName: "AuthMfa" */ '../views/auth-mfa/password-reset.vue')
// MFA 重置（邮件回调）
const mfaResetView = () => import(/* webpackChunkName: "AuthMfa" */ '../views/auth-mfa/mfa-reset.vue')
// 重置密码（邮件链接落地页，cmForm）
const resetPasswordView = () => import(/* webpackChunkName: "AuthMfa" */ '../views/auth-mfa/reset-password.vue')
// 重置 MFA（邮件链接落地页）
const resetMfaView = () => import(/* webpackChunkName: "AuthMfa" */ '../views/auth-mfa/reset-mfa.vue')
// 分组管理
const groupManageView = () => import(/* webpackChunkName: "GroupManage" */ '../views/dashboard/manage/group-manage/group-manage.vue')
export const routes: Array<RouteRecordRaw> = [, {
  path: '/',
  redirect: '/dashboard'
}, {
  path: '/login',
  name: 'Login',
  component: loginView
}, {
  path: '/login-transit',
  name: 'LoginTransitView',
  component: loginTransitView
}, {
  path: '/cascade-login',
  name: 'CascadeLoginView',
  component: cascadeLoginView
}, {
  path: '/authorize',
  name: 'AuthorizeView',
  component: authorizeView
}, {
  path: '/password-reset',
  name: 'PasswordReset',
  component: passwordResetView
}, {
  path: '/mfa-reset',
  name: 'MfaReset',
  component: mfaResetView
}, {
  path: '/reset-password',
  name: 'ResetPassword',
  component: resetPasswordView
}, {
  path: '/reset-mfa',
  name: 'ResetMfa',
  component: resetMfaView
}, {
  path: '/team',
  name: 'Team',
  component: teamView
}, {
  path: '/preview',
  name: 'preview',
  component: preview
}, {
      path: '/word-remote',
      name: 'word-remote',
      component: wordRemoteView,
    },
    {
  path: '/cloud-library-update',
  name: 'CloudLibraryUpdate',
  component: cloudLibraryUpdateView
}, {
  path: '/dashboard',
  name: 'Dashboard',
  component: dashboardView,
  redirect: '/dashboard/overview',
  children: [
    {
      path: 'overview',
      name: 'Overview',
      component: overviewView
    },
    {
      path: 'client',
      name: 'client',
      component: clientView,
    },
    {
      path: 'hardware',
      name: 'hardware',
      component: hardwareView,
    },
    {
      path: 'client-alive',
      name: 'client-alive',
      component: clientAliveView,
    },
    {
      path: 'loaris-trojan-remover',
      name: 'loaris-trojan-remover',
      component: loarisTrojanRemoverView,
    },
    {
      path: 'base-line',
      name: 'base-line',
      component: baseLineView,
    },
    {
      path: 'vulnerability-fix',
      name: 'vulnerability-fix',
      component: vulnerabilityFixView,
    },
    {
      path: 'examination-status',
      name: 'examination-status',
      component: examinationStatusView,
    },
    {
      path: 'security-event',
      name: 'security-event',
      component: securityEventView,
    },
    {
      path: 'group-policy',
      name: 'group-policy',
      component: groupPolicyView,
    }, {
      path: 'policy-deploy',
      name: 'policy-deploy',
      component: policyDeployView,
    }, {
      path: 'internet-restriction',
      name: 'internet-restriction',
      component: internetRestrictionView,
    },{
      path: 'access-restriction',
      name: 'access-restriction',
      component: accessRestrictionView,
    },{
      path: 'ip-address-blocking',
      name: 'ip-address-blocking',
      component: iPAddressBlockingView,
    }, {
      path: 'equipment-statistics',
      name: 'equipment-statistics',
      component: usbStatisticsView,
    }, {
      path: 'equipment-approve',
      name: 'equipment-approve',
      component: usbApproveView,
    }, {
      path: 'usb-policy',
      name: 'usb-policy',
      component: usbPolicyView,
    }, {
      path: 'usb-policy-edit',
      name: 'usb-policy-edit',
      component: usbPolicyEditView,
      props: (route) => ({
        policyId: (route.query.policy_id as string) || '',
        fromGroupId: (route.query.from_group_id as string) || undefined,
      }),
    }, {
      path: 'boot-optimize',
      name: 'boot-optimize',
      component: bootOptimizeView,
    }, {
      path: 'software-usage',
      name: 'software-usage',
      component: softwareUsageView,
    }, {
      path: 'port-manage',
      name: 'port-manage',
      component: portManageView,
    }, {
      path: 'popup-intercept',
      name: 'popup-intercept',
      component: popUpInterceptView,
    }, {
      path: 'software-dispatcher',
      name: 'software-dispatcher',
      component: softwareDispatcherView,
    }, {
      path: 'genuine-software',
      name: 'genuine-software',
      component: genuineSoftwareView,
    }, {
      path: 'genuine-software-usage',
      name: 'genuine-software-usage',
      component: genuineSoftwareUsageView,
    }, {
      path: 'software-disabled',
      name: 'software-disabled',
      component: softwareDisabledView,
    }, {
      path: 'software-disabled-edit',
      name: 'software-disabled-edit',
      component: softwareDisabledEditView,
      props: (route) => ({
        policyId: (route.query.policy_id as string) || '',
        fromGroupId: (route.query.from_group_id as string) || undefined,
        readonly: Boolean(route.query.readonly),
      }),
    }, {
      path: 'screen-watermark',
      name: 'screen-watermark',
      component: screenWatermarkView,
    }, {
      path: 'screen-watermark-edit',
      name: 'screen-watermark-edit',
      component: screenWatermarkEditView,
    },{
      path: 'ransomware-incident',
      name: 'ransomware-incident',
      component: ransomwareIncidentView,
    },
    {
      path: 'sensitive-file-scanning',
      name: 'sensitive-file-scanning',
      component: sensitiveFileScanningView,
    },{
      path: 'data-discovery/:id',
      name: 'data-discovery',
      component: sensitiveDataDiscoveryView,
    },{
      path: 'file-control-strategy-setting',
      name: 'file-control-strategy-setting',
      component: fileControlStrategySettingView,
    },
    {
      path: 'approval-terminal-file-outsourcing',
      name: 'approval-terminal-file-outsourcing',
      component: approvalTerminalFileOutsourcingView,
    },
    {
      path: 'approval-center',
      name: 'approval-center',
      component: approvalCenterView
    },
     {
      path: 'process-control',
      name: 'process-control',
      component: processControlView,
    },{
      path: 'remote-authentication',
      name: 'remote-authentication',
      component: remoteAuthenticationStrategyView,
    },{
      path: 'remote-login-log',
      name: 'remote-login-log',
      component: remoteAuthenticationLoginLogyView,
    }, {
      path: 'process-control-edit',
      name: 'process-control-edit',
      component: processControlEditView,
      props: (route) => ({
        policyId: (route.query.policy_id as string) || '',
        fromGroupId: (route.query.from_group_id as string) || undefined,
        readonly: Boolean(route.query.readonly),
      }),
    }, {
      path: 'file-dispatch',
      name: 'file-dispatch',
      component: fileDispatchView,
    }, {
      path: 'software-manage',
      name: 'software-manage',
      component: softwareManageView,
    }, {
      path: 'admin-account-settings',
      name: 'admin-account-settings',
      component: adminListContainerView
    },{
      path: 'invite-list',
      name: 'invite-list',
      component: InviteListView,
    }, {
      path: 'device-status',
      name: 'device-status',
      component: deviceStatusView,
    }, {
      path: 'message-push',
      name: 'message-push',
      component: messagePushView,
    }, {
      path: 'warning-log',
      name: 'warning-log',
      component: warningLogView,
    }, {
      path: 'admin-log',
      name: 'admin-log',
      component: adminLogView,
    }, {
      path: 'virus-log',
      name: 'virus-log',
      component: virusLogView,
    }, {
      path: 'hardware-modify-log',
      name: 'hardware-modify-log',
      component: HardwareModifyLogView,
    }, {
      path: 'software-modify-log',
      name: 'software-modify-log',
      component: SoftwareModifyLogView,
    }, {
      path: 'in-out-log',
      name: 'in-out-log',
      component: InoutLogView,
    }, {
      path: 'soft-disabled-log',
      name: 'soft-disabled-log',
      component: SoftDisabledLogView,
    }, {
      path: 'process-control-log',
      name: 'process-control-log',
      component: ProcessControlLogView,
    }, {
      path: 'genuine-software-log',
      name: 'genuine-software-log',
      component: GenuineSoftwareLogView,
    },
    {
      path: 'outbound-control-log',
      name: 'outbound-control-log',
      component: OutboundControlLogView,
    },
    {
      path: 'outbound-control-log-near',
      name: 'outbound-control-log-near',
      component: OutboundControlLogView,
    },
    {
      path: 'trouble-shoot-log',
      name: 'trouble-shoot-log',
      component: TroubleShootLogView,
    },
    {
      path: 'traffic-control',
      name: 'traffic-control',
      component: TrafficControlView,
    },
    {
      path: 'terminal-traffic-state-list',
      name: 'terminal-traffic-state-list',
      component: TerminalTrafficStateListView,
    },
    {
      path: 'ip-address-blocking-log',
      name: 'ip-address-blocking-log',
      component: IpAddressBlockingLogView,
    },
    {
      path: '/dashboard/file-whitelist',
      name: 'fileWhitelist',
      component: fileWhitelistView
    },
    {
      path: 'version-update',
      name: 'version-update',
      component: versionUpdateView,
    },
    {
      path: 'mail-setting',
      name: 'mail-setting',
      component: mailSetting,
    },
    {
      path: 'system-config',
      name: 'system-config',
      component: systemConfig,
    },
    {
      path: 'run-status',
      name: 'run-status',
      component: runStatusView,
    },
    {
      path: 'group-manage',
      name: 'group-manage',
      component: groupManageView,
    }, {
      path: 'ldap-sync-setting',
      name: 'ldap-sync-setting',
      component: ldapSyncSettingView,
    },
    {
      path: 'asset-registration',
      name: 'asset-registration',
      component: assetRegistration,
    },
    {
      path: 'terminal-discovery',
      name: 'terminal-discovery',
      component: terminalDiscoveryView,
    },
    {
      path: 'cloud-feature-offline-library',
      name: 'cloud-feature-offline-library',
      component: cloudFeatureOfflineLibraryView,
    },
    {
      path: 'service-subscribe',
      name: 'service-subscribe',
      component: serviceSubscribeView,
    },
    {
      path: 'ai-assistant-detail',
      name: 'ai-assistant-detail',
      component: aiAssistantDetailView,
    },
    {
      path: 'my-subscribe',
      name: 'my-subscribe',
      component: mySubscribeView,
    },
    {
      path: 'order-history',
      name: 'order-history',
      component: IS_PRIVATE ? orderHistoryPrivateView : orderHistoryView,
    },
    {
      path: 'contract-info',
      name: 'contract-info',
      component: contractInfoView,
    },
    {
      path: 'subscribe-details',
      name: 'subscribe-details',
      component: subscribeDetailsView,
      props: route => {
        const renewRaw = route.query.renew_all
        const renewAll = renewRaw === 'true'
          || (Array.isArray(renewRaw) && renewRaw[0] === 'true')
        return {
          drawerMode: false,
          initialRouteQuery: route.query,
          renewAll,
        }
      },
    },
    {
      path: 'buy-more',
      name: 'buy-more',
      component: buyMoreView,
    },
    {
      path: 'cascade-branch-overview',
      name: 'cascade-branch-overview',
      component: cascadeBranchOverviewView,
    },
    {
      path: 'cascade-manage',
      name: 'cascade-manage',
      component: cascadeManageView,
    },
    {
      path: 'cascade-approval',
      name: 'cascade-approval',
      component: cascadeApprovalView,
    },{
      path: 'response-handle',
      name: 'response-handle',
      component: responseHandleView,
    }
  ]
}, {
  path: '/remote-control',
  name: 'RemoteControl',
  component: remoteControl
}, {
  path: '/remote-vnc',
  name: 'RemoteVnc',
  component: remoteVnc
}, {
  path: '/remote-ssh',
  name: 'RemoteSsh',
  component: remoteSsh
}, {
  path: '/help/repair-help',
  name: 'repairHelpView',
  component: repairHelpView
}, {
  path: '/help/subscribe-help',
  name: 'subscribeHelpView',
  component: subscribeHelpView
}, {
  path: '/help/linux-repair-help',
  name: 'linuxRepairHelpView',
  component: linuxRepairHelpView
}, {
  path: '/help/domain-deployment',
  name: 'domainDeployment',
  component: domainDeploymentView
}, {
  path: '/help/watermark-decryption',
  name: 'watermarkDecryption',
  component: watermarkDecryptionView
},]

export const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
